import React from "react";
import Drawer from "react-modern-drawer";

import { CheckoutConfigurationType } from "@is/constants";
import BasketDrawerContent from "@is/features/BasketDrawer/BasketDrawerContent";

import css from "./BasketDrawer.module.css";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onGoToCheckout: (
    checkoutConfigurationsType: CheckoutConfigurationType
  ) => void;
};

const BasketDrawer = ({ isOpen, onClose, onGoToCheckout }: Props) => {
  return (
    <Drawer
      open={isOpen}
      size="100vh"
      onClose={onClose}
      direction="bottom"
      enableOverlay={false}
      className={css.drawer}
      style={{ boxShadow: "none", border: "none" }}
    >
      {isOpen && (
        <BasketDrawerContent
          isOpen={isOpen}
          onClose={onClose}
          onGoToCheckout={onGoToCheckout}
        />
      )}
    </Drawer>
  );
};

export default BasketDrawer;
